<div id="historico-acoes">
  <div class="divSlideContent">
    <div class="row no-gutters" *ngIf="!roteiroCrossdocking">
      <div class="form-group">
        <div class="col-xs-12 search">
          <input id="historico-acoes__pesquisa-acoes" class="form-control .input-lg size-custom-input" type="text" name="data" 
            placeholder="Buscar por ação ou cliente" [(ngModel)]="pesquisaAcoes">
          <a class="bt-input-clear chama-roteiro btn-hover" (click)="limpaBuscaAcao()">
            <img src="assets/img/icon_clear_bt.png">
          </a>
        </div>
      </div>
    </div>

    <div class="conteudo-checkbox">
      <label class="mb-0">
        <input
          type="checkbox"
          [checked]="exibirTodos"
          (click)="alteraExibirTodos()"
        />
        <span></span>
      </label>
      <span class="text-checkbox">Exibir todos no mapa</span>
    </div>
  
    <div>
      <ul id="timeline-acoes">
        
        <div *ngFor="let historicoAcoesPorDia of agrupadoDiaCliente">

          <app-bar-date [infoDia]="historicoAcoesPorDia[0][0].dia + 1 " [data]="historicoAcoesPorDia[0][0].Data"  class="w-100"></app-bar-date>

          <li class="sincronizacao" *ngFor="let itens of historicoAcoesPorDia | searchfilter:pesquisaAcoes:false">

            <div *ngIf="itens[0].CodigoCliente == 0;else acaoPedido">
              <div class="timeline-acoes__content">

                <span class="icon">
                  <img [src]='itens[0].iconeAcao' class="btn-hover" (click)="exibirAcaoMapa(itens[0].IdCoordenada, itens[0].check)"/>
                </span>      
   
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <p class="motivo">{{ itens[0].Acao }} <span class="hora">{{ itens[0].Data.replace('Z' , '') | date:'HH:mm' }}</span></p>
                    <p class="cliente" [hidden]="!itens[0].km">{{ itens[0].km}} km</p>
                  </div>
                  <div>
                    <app-texto-link 
                      *ngIf="kmOdometroInicio != null && (itens[0].Acao == 'Odômetro - Registro Inicial' || itens[0].Acao == 'Odômetro - Registro Final')"
                      (click)="downloadOdometro()"
                      icone="download_comprovante_dark"
                      titulo="Baixar imagem" class="pe-2" ></app-texto-link>
                  </div>
                </div>
                <div class="mostra-acao"  hidden="true">
                  <div class="checkbox">
                    <input type="checkbox" data-size="small" id="checkbox-marcar-acao{{itens[0].IdCoordenada}}"
                      [value]="itens[0].IdCoordenada" >
                    <label for="checkbox-marcar-acao{{itens[0].IdCoordenada}}"></label>
                  </div>
                </div>
              </div>
            </div>

            
            <ng-template #acaoPedido>
               
                  <div class="timeline-acoes__content">
                    
                    <span class="icon" style="margin-left: -2px;">
                      <img [src]='itens[0].urlIcone' class="btn-hover"  (click)="exibirAcaoMapa(itens[0].IdCoordenada, itens[0].check)" />
                    </span>
          
                    <div *ngFor="let item of itens;let i = index "  [ngClass]="{'mt-4': i > 0,'d-flex': i > 0, 'align-items-center': i > 0 }" >                   
                    <span *ngIf="i > 0" class="me-2">
                      <img [src]='item.iconeAcao' class="btn-hover"  (click)="exibirAcaoMapa(item.IdCoordenada, item.check)"/>
                    </span>
                    
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <p class="motivo">{{ item.Acao }} <span class="hora">{{ item.Data.replace('Z' , '') | date:'HH:mm' }}</span></p>
                        <p class="cliente" [hidden]="item.CodigoCliente == 0 || i != 0">{{ item.CodigoCliente }} - {{ configNomeClienteExibicao == enumConfiguracaoInfoCliente.NomeFantasia? item.NomeFantasia : item.RazaoSocial }}</p>
                        <p class="cliente" [hidden]="!item.km">{{ item.km}} km</p>
                      </div>
                      <div *ngIf="mostraComprovanteApp && (item.Acao == 'Entrega realizada' || item.Acao == 'Entrega realizada com exceção')">
                        <app-texto-link  *ngIf="!item.ColetaAssinaturaRecusada;else recusaColetaMotorista"
                        titulo="Ver dados recebedor" icone='dados_recebedor'                                               
                        data-bs-target="#popupID-dados-recebedor"
                        (click)="comprovanteEntrega(item)"
                        ></app-texto-link>
                        <ng-template #recusaColetaMotorista>
                          <app-foto-assinatura-nao-coletada></app-foto-assinatura-nao-coletada>
                        </ng-template>             
                      </div>
                    </div>

                    <div class="mostra-acao" hidden="true">
                      <div class="checkbox">
                        <input type="checkbox" data-size="small" id="checkbox-marcar-acao{{item.IdCoordenada}}"
                          [value]="item.IdCoordenada" >
                        <label for="checkbox-marcar-acao{{item.IdCoordenada}}"></label>
                      </div>
                    </div>
                  </div>
                </div> 
            </ng-template>
            
           
          
           

          </li>

        </div>
      </ul>
    </div>
  </div>
</div>
